import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import EXIF from 'exif-js';
import apiClient from "../../../api/apiClient";
import { publish, subscribe, unsubscribe } from '../../../utils/pubsubWrapper';
import { Form, Button, Row, Col, Alert, ProgressBar, Spinner } from "react-bootstrap";
import { Input, AlertMassage } from "../../shared";
import { checkVideoPath } from '../../../utils/utils';
import { VideoPlayIcon, BackArrowIcon } from "../../../utils/FontIcon";
import { UPLOADVIDEO, VIDEOS } from '../../../utils/ApiEndPoint';

export default function AddVideo() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    title: "",
    tags: "",
    description: "",
    topicValue: '',
    topic: '',
    skillLevel: '',
    video: null,
    thumbnail: null,
    duration: '',
  });
  const [videoMetadata, setVideoMetadata] = useState({});
  const [imageMetadata, setImageMetadata] = useState({});
  const [progress, setProgress] = useState(0);
  const [errors, setErrors] = useState({});
  const videoInputRef = useRef(null);
  const thumInputRef = useRef(null);
  const [isEditMode, setIsEditMode] = useState({ mode: false, id: '', createdBy: '', updatedBy: '' });
  const [showAlert, setShowAlert] = useState({
    type: '',
    title: '',
    msg: ``,
    show: false

  })
  const [waitForResponse, setWaitForResponse] = useState(false);
  useEffect(() => {
    const pubsubToken = subscribe('EDIT_VIDEO', (video) => {
      const selectedCategory = categary.find(cat => cat.label === video.topic);
      setForm({
        title: video.title,
        tags: video.tags.join(),
        description: video.description,
        topicValue: selectedCategory ? selectedCategory.value : '',
        topic: video.topic,
        skillLevel: video.skillLevel,
        video: video.videoUrl,
        thumbnail: video.thumbnailUrl,
        duration: video.duration,
      });
      setShowAlert({
        type: '',
        title: '',
        msg: ``,
        show: false
      })
      setErrors({});
      setIsEditMode({ mode: true, id: video._id, createdBy: video.createdBy, updatedBy: video.updatedBy });
    });
    return () => unsubscribe(pubsubToken);
  }, []);
  const categary = [
    { value: '0001', label: 'General Courses (open for all)' },
    { value: '0002', label: 'Policy & Implementation (Government Officials)' },
    { value: '0003', label: 'Banking & Financial Institutions (Banking officials)' },
    { value: '0004', label: 'Insurance Operations & field implementation' },
    { value: '0005', label: 'Krishi Rakshak Portal & Helpline (KRPH)' },
    { value: '0006', label: 'Enrollment & Facilitation (CSCs, VLEs, and other Enrollment Agents)' },
  ]
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
    if (name === 'topicValue') {
      const selectedCategory = categary.find(cat => cat.value === value);
      setForm((prev) => ({
        ...prev,
        topic: selectedCategory ? selectedCategory.label : '',
      }));
    }

    if (files) {
      const file = files[0];
      const fileUrl = URL.createObjectURL(file);
      const basicMeta = {
        name: file.name,
        size: (file.size / 1024 / 1024).toFixed(2),
        type: file.type,
        lastModified: new Date(file.lastModified).toLocaleString(),
      };
      if (file.type.startsWith('image/')) {
        extractImageMetadata(file, basicMeta);
      } else if (file.type.startsWith('video/')) {
        extractVideoMetadata(fileUrl, basicMeta);
      } else {
        console.log("Unsupported file type:", file.type);
        // setMetadata(basicMeta);
      }
    }
    setErrors((prev) => ({ ...prev, [name]: undefined }));
  };
  const extractImageMetadata = (file, basicMeta) => {
    const reader = new FileReader();
    reader.onload = function (e) {
      EXIF.getData(file, function () {
        const allMetaData = EXIF.getAllTags(this);
        setImageMetadata({ ...basicMeta, ...allMetaData });
      });
    };
    reader.readAsArrayBuffer(file);
  };
  const extractVideoMetadata = (url, basicMeta) => {
    const video = document.createElement('video');
    video.preload = 'metadata';

    video.onloadedmetadata = () => {
      const videoMeta = {
        duration: video.duration,
        width: video.videoWidth,
        height: video.videoHeight,
      };
      setForm((prev) => ({
        ...prev,
        duration: video.duration,
      }));
      setVideoMetadata({ ...basicMeta, ...videoMeta });
    };

    video.src = url;
  };
  const validate = () => {
    const newErrors = {};
    if (!form.title.trim()) newErrors.title = "Title is required";
    if (!form.tags.trim()) newErrors.tags = "Keywords are required";
    if (!form.description.trim()) newErrors.description = "Description is required";
    if (!form.topicValue.trim()) newErrors.topicValue = "Category is required";
    if (!form.skillLevel.trim()) newErrors.skillLevel = "Difficulty level is required";
    if (!form.video) newErrors.video = "Video file is required";
    else if (form.video && !isEditMode.mode && (!videoMetadata?.size || !videoMetadata?.duration)) newErrors.video = "Chose a calid Video file";
    else if (form.video && !isEditMode.mode && videoMetadata.size > 200) newErrors.video = "Video Size must be less then 200 mb";
    if (!form.thumbnail) newErrors.thumbnail = "Thumbnail is required";
    else if (form.thumbnail && !isEditMode.mode && imageMetadata.size > 5) newErrors.thumbnail = "Iamge Size must be less then 5 mb";
    return newErrors;
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setWaitForResponse(true);
    !isEditMode.mode ? savedata() : saveEdited();
  };
  const savedata = () => {
    const data = new FormData();
    Object.keys(form).forEach(key => data.append(key, form[key]));
    data.append('mediaMetadata', videoMetadata);
    data.append('size', videoMetadata.size);
    data.delete('topicValue');
    let tempAlert = {
      type: 'danger',
      title: 'Error',
      msg: '',
      show: true
    }
    apiClient.post(UPLOADVIDEO, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: (progressEvent) => {
        const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        setProgress(percent);
      }
    }).then((response) => {
      if (response.status === 201) {
        resetForm();
        tempAlert.msg = '✅ Video uploaded successfully! it will available soon ';
        tempAlert.type = 'success';
        tempAlert.title = 'success';
        setShowAlert(tempAlert);
        publish('FETCH_VIDEO');
      } else {
        tempAlert.msg = '❌ Upload failed.';
        setShowAlert(tempAlert);
      }
    }).catch((error) => {
      tempAlert.msg = '❌ Upload failed.'
      setShowAlert(tempAlert);
    }).finally(() => {
      setWaitForResponse(false);
      setProgress(0);
    })

  }
  const saveEdited = () => {
    const data = {
      "id": isEditMode.id,
      "title": form.title,
      "description": form.description,
      "tags": form.tags.split(',').map(tag => tag.trim()).filter(tag => tag),
      "videoUrl": form.video,
      "thumbnailUrl": form.thumbnail,
      "duration": form.duration,
      "topic": form.topic,
      "skillLevel": form.skillLevel,
      "createdBy": isEditMode.createdBy,
      "updatedBy": isEditMode.updatedBy
    }
    let tempAlert = {
      type: 'danger',
      title: 'Error',
      msg: '',
      show: true
    }
    apiClient.put(`${VIDEOS}/${isEditMode.id}`, data)
      .then((response) => {
        if (response.status === 200) {
          resetForm();
          tempAlert.msg = '✅ Video updated successfully!';
          tempAlert.type = 'success';
          tempAlert.title = 'success';
          setShowAlert(tempAlert);
          publish('FETCH_VIDEO');
        } else {
          tempAlert.msg = '❌ update failed.';
          setShowAlert(tempAlert)
        }
      }).catch((error) => {
        tempAlert.msg = '❌ update failed.'
        setShowAlert(tempAlert)
      }).finally(() => {
        setWaitForResponse(false);
      });
  }
  const handelGotoCourse = (e) => {
    navigate('/createcourse');
  }
  const resetForm = () => {
    setForm({
      title: "",
      tags: "",
      description: "",
      topicValue: '',
      topic: '',
      skillLevel: '',
      video: null,
      thumbnail: null,
      duration: '',
    });

    if (videoInputRef.current) {
      videoInputRef.current.value = '';
    }
    if (thumInputRef.current) {
      thumInputRef.current.value = '';
    }
    setVideoMetadata({});
    setImageMetadata({});
    setIsEditMode({
      mode: false,
      id: '',
      createdBy: '',
      updatedBy: ''
    });
    setErrors({});
  }
  const hideAlert = () => {
    setShowAlert({
      type: '',
      title: '',
      msg: '',
      show: false
    })
  }
  return (
    <div className="add-video-bg" >
      <Row>
        <Col xs={6} md={10}>
          <h4 className="mb-0 fw-bold">Add &amp; Manage Video</h4>
          <div className="mb-2 ms-1 small fw-semibold text-secondary">(Upload/Listing)</div>
        </Col>

        <Col xs={6} md={2} className="text-end">
          <Button variant="outline-dark" onClick={handelGotoCourse} title="Go to course"><BackArrowIcon /> Go to course</Button>
        </Col>
      </Row>
      <Row>
        <Col lg={12} className="add-video-container">

          {(progress > 0 && progress < 100) && (
            <Row>
              <Alert variant="light" className="mt-3">
                <ProgressBar striped animated variant="success" now={progress} label={`${progress}%`} />
              </Alert>
            </Row>
          )}
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col lg={12} className="pb-2">
                <div className="mb-2 fw-semibold fs-8 onerem">Start building your video library.</div>
              </Col>
              <Col md={7} className="pe-md-5 border-end" style={{ borderColor: "#dee2e6", }}>
                <Row>

                  <Col md={6}>
                    <Input
                      label="Title"
                      isMandetory={true}
                      name="title"
                      value={form.title}
                      onChange={handleChange}
                      placeholder="enter your video title"
                      isInvalid={!!errors.title}
                      feedback={errors.title}
                      inlineFeedback={true}
                      maxLength={80}
                    />
                  </Col>
                  <Col md={6}>
                    <Input
                      label="Keywords"
                      isMandetory={true}
                      name="tags"
                      value={form.tags}
                      onChange={handleChange}
                      placeholder="enter keywords"
                      isInvalid={!!errors.tags}
                      feedback={errors.tags}
                      inlineFeedback={true}
                    />
                  </Col>
                  <Col md={6}>
                    <Input
                      label="Category"
                      type="select"
                      name="topicValue"
                      value={form.topicValue}
                      onChange={handleChange}
                      isInvalid={!!errors.topicValue}
                      feedback={errors.topicValue}
                      multiple={false}
                      options={categary}
                      isMandetory={true}
                      inlineFeedback={true}
                    />
                  </Col>
                  <Col md={6}>
                    <Input
                      label="Difficulty level"
                      type="select"
                      name="skillLevel"
                      value={form.skillLevel}
                      onChange={handleChange}
                      isInvalid={!!errors.skillLevel}
                      feedback={errors.skillLevel}
                      multiple={false}
                      options={[
                        { value: 'beginner', label: 'Beginner' },
                        { value: 'intermediate', label: 'Intermediate' },
                        { value: 'advanced', label: 'Advanced' }
                      ]}
                      isMandetory={true}
                      inlineFeedback={true}
                    />
                  </Col>
                  <Col md={12}>
                    <Input
                      label="Description"
                      isMandetory={true}
                      name="description"
                      value={form.description}
                      onChange={handleChange}
                      placeholder="enter description"
                      isInvalid={!!errors.description}
                      feedback={errors.description}
                      as="textarea"
                      rows={3}
                      inlineFeedback={true}
                      // maxLength={500}
                    />
                  </Col>
                </Row>
              </Col>
              {isEditMode.mode ? <Col md={5} className="ps-md-5 mt-md-0 d-flex">
                <Row>
                  <Col lg={12} className="p-relative" style={{ cursor: 'not-allowed' }}>
                    <div className='p-relative' style={{ width: '480px', height: '270px' }}>
                      <img
                        src={(form.thumbnail && checkVideoPath(form.video)) ? form.thumbnail : '/lms/img/defaultthumb.jpg'}
                        className='img-fluid img-thumbnail' style={{ width: '480px', height: '270px' }}
                      />
                      <VideoPlayIcon className='video-playbtn' style={{ width: '20%', left: '40%' }} />
                    </div>

                  </Col>
                </Row>
              </Col> :
                <Col md={5} className="ps-md-5 mt-md-0" style={{ position: 'relative', top: '-1rem' }}>
                  <Form.Group className="mb-2">
                    <Form.Label className="fs-8">
                      <span className="d-block fw-600">Upload Video<span style={{ color: 'red' }}>*</span></span>
                      <small className="fw-semibold">(supported formats: MP4) | (Max Size : 200MB)</small>
                    </Form.Label>
                    <div className="d-flex align-items-center gap-2">
                      <Form.Control
                        type="file"
                        name="video"
                        onChange={handleChange}
                        style={{ fontSize: '0.8rem', lineHeight: '2.4', color: '#999', minHeight: '33px' }}
                        className={!!errors.video ? 'invalidinput' : ''}
                        accept=".mp4"
                        ref={videoInputRef}
                      />
                    </div>
                    {errors.video ?
                      <Form.Control.Feedback type="invalid" className="d-block">{errors.video}</Form.Control.Feedback>
                      :
                      <Form.Text >
                        <div className={form.duration ? "hinttxt" : ''} style={{ minHeight: '20px' }}>{form.duration && <span><strong>Duration :</strong> {form.duration.toFixed(2)} sec.  <strong>|   Size :</strong> {videoMetadata.size} MB</span>}</div>
                      </Form.Text>}
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label className="fs-8">
                      <span className="d-block fw-600">Upload Thumbnail  <span style={{ color: 'red' }}>*</span></span>
                      <small className="fw-semibold">(supported formats: jpeg, png)  | (Max Size : 5MB)</small>

                    </Form.Label>
                    <div className="d-flex align-items-center gap-2">
                      <Form.Control
                        type="file"
                        name="thumbnail"
                        onChange={handleChange}
                        style={{ fontSize: '0.8rem', lineHeight: '2.4', color: '#999', minHeight: '33px' }}
                        className={!!errors.thumbnail ? 'invalidinput' : ''}
                        accept=".jpeg,.jpg,.png"
                        ref={thumInputRef}
                      />
                    </div>
                    {errors.thumbnail ?
                      <Form.Control.Feedback type="invalid" className="d-block">{errors.thumbnail}</Form.Control.Feedback>
                      :
                      <Form.Text>
                        <div className={imageMetadata.size ? "hinttxt" : ''} style={{ minHeight: '20px' }}>{imageMetadata.size && <span><strong>Size:</strong> {imageMetadata.size} MB</span>}</div>
                      </Form.Text>
                    }


                  </Form.Group>
                </Col>}
            </Row>
            <Row>
              {/* {progress <= 0 && ( */}
              <div className="d-flex gap-3 justify-content-end">
                <Button variant="outline-secondary" type="button" title="Reset" className="px-4" disabled={waitForResponse} onClick={(e) => { resetForm(); }}>
                  Reset
                </Button>
                <Button type="submit" title="Save" className="save-btn px-5" disabled={waitForResponse}>
                  { isEditMode.mode ? 'Update' : 'Save'}
                </Button>
              </div>
              {/* )} */}
            </Row>
          </Form>

        </Col>
      </Row>
      {showAlert.show &&
        <AlertMassage
          show={showAlert.show}
          type={showAlert.type}
          title={showAlert.title}
          massage={showAlert.msg}
          hideAlert={hideAlert} />
      }
    </div>
  );
}